import { render, staticRenderFns } from "./detailCustom.vue?vue&type=template&id=6171e85c&scoped=true"
import script from "./detailCustom.vue?vue&type=script&lang=js"
export * from "./detailCustom.vue?vue&type=script&lang=js"
import style0 from "./detailCustom.vue?vue&type=style&index=0&id=6171e85c&prod&scoped=true&lang=css"
import style1 from "./detailCustom.vue?vue&type=style&index=1&id=6171e85c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6171e85c",
  null
  
)

export default component.exports